import * as React from 'react'
import { Droppable } from 'react-beautiful-dnd';
import { getUIFields, IUIFieldDefinition } from '../common/common';
import { DragWrapper } from '../common/dnd';

interface IFieldPanelProps {

}

const FieldPanel: React.FunctionComponent<IFieldPanelProps> = (props) => {

    let fields = getUIFields();
    return <div className='wd-field-panel'>
        {/* <div className='wd-field-panel-title'>Fields</div> */}
        <div className="not-selected">Drag and drop an item to highlighted are and click on it to configure the properties</div>

        <Droppable droppableId="fields" isDropDisabled={true}>
            {
                (provided, snapshot) => {
                    return <div className='wd-field-panel-field-list' ref={provided.innerRef}>
                        {
                            fields.map((f, index) => {
                                return <FieldWrapper index={index} field={f} />
                            })
                        }
                        {provided.placeholder}
                    </div>
                }
            }
        </Droppable>
    </div>
}

const FieldWrapper: React.FunctionComponent<{ field: IUIFieldDefinition, index: number }> = (props) => {
    return (
        <DragWrapper type='fieldType' data={props.field} index={props.index}>
            {
                (provided, snapshot) => {
                    return <><div className='wd-field-item' {...provided.draggableProps} {...provided.dragHandleProps} ref={provided.innerRef} >
                        <div className='wd-field-title'>{props.field.id}</div>
                        <div className='wd-field-description'>{props.field.description}</div>
                    </div>
                        {
                            snapshot.isDragging && <div className='wd-field-item' >
                                <div className='wd-field-title'>{props.field.id}</div>
                                <div className='wd-field-description'>{props.field.description}</div>
                            </div>
                        }
                    </>;
                }
            }
        </DragWrapper>
    )
};

export default FieldPanel